module.exports = __webpack_public_path__ + "img/avp_bck_alt_phone@2x.c2407df.jpg";